
import { toast } from 'react-toastify'
import { TFunction } from 'i18next'
type NotifyPaymentStatusProps = {
    locationSearch: string
    t: TFunction
};

export function NotifyPaymentStatus({ locationSearch, t }: NotifyPaymentStatusProps): void {
    const params = new URLSearchParams(locationSearch);

    if (params.get("status") === "ok") {
        toast.info(t('paymentPage.apartmentPublished'));
        sessionStorage.setItem('paymentStatusOk', 'true');
    } else if (params.get("status") === "fail" || params.get("status") === "error") {
        toast.info(t('paymentPage.paymentFailed'));
    }
}